import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const CommonModal = ({
  isOpen,
  toggle,
  title = "",
  size = "md",
  centered = true,
  children,
  height = "auto"
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size={size} centered={centered}>
      {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
      <ModalBody style={{height}}>{children}</ModalBody>
    </Modal>
  );
};

export default CommonModal;
